import type { RefreshTokenResponse } from '@/types/api'

let applyTokensHandler: ((tokens: RefreshTokenResponse) => void) | undefined
let logoutHandler: (() => Promise<void>) | undefined

export function wireAuthHandlers(handlers: {
  applyTokens: (tokens: RefreshTokenResponse) => void
  logout: () => Promise<void>
}): void {
  applyTokensHandler = handlers.applyTokens
  logoutHandler = handlers.logout
}

export function applyRefreshedAuthTokens(tokens: RefreshTokenResponse): void {
  applyTokensHandler?.(tokens)
}

export async function logoutFromApi(): Promise<void> {
  await logoutHandler?.()
}
